import { Alert, Snackbar } from "@mui/material";

function ToastMessage ({ type, message, onClose }) {
    return (
        <Snackbar
            open={true}
            autoHideDuration={3000}
            onClose={onClose}
        >
            <Alert
                onClose={onClose}
                severity={type === 0 ? 'warning' : 'success'}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}
export default ToastMessage;